class CountrySelectorContainer extends HTMLElement {
  constructor() {
    super();
    this.countrySelect = this.querySelector('select[name="address[country]"]');
  }

  connectedCallback() {
    if (this.countrySelect) {
      this.countrySelect.addEventListener('change', () => {
        if (this.countrySelect.value) {
          this.classList.remove('empty');
          this.classList.add('selected');
        } else {
          this.classList.add('empty');
          this.classList.remove('selected');
        }
      });
    }
  }
}

customElements.define('country-selector-container', CountrySelectorContainer);